export const outletsRequestDynamicContextRequest_v1_schema = {
  type: 'object',
  properties: {
    target: {
      type: 'string',
    },
    outletSettings: {},
  },
  required: ['target'],
};
